import { useQuery } from "@tanstack/react-query";
import { getInvoiceById } from "@/api/v1-jwt/invoice/invoice";
import { useAuth } from "@/providers/auth";

export const useInvoice = ({
  invoiceId,
  queryFn,
  queryKey,
  filters = {},
  enabled,
  ...rest
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const userId =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!userId && enabled !== false && !!invoiceId;

  return useQuery({
    queryKey: ["invoices", invoiceId],
    queryFn: async () => {
      return await getInvoiceById({ userId: userId, invoiceId });
    },
    staleTime: 5 * 60 * 1000,
    enabled: isEnabled,
    ...rest,
  });
};
